<h2>{{'funnel.modal.register.title' | translate}}</h2>
<p [innerHTML]="'funnel.modal.register.body' | translate"></p>
<button mat-flat-button mat-dialog-close>{{'funnel.model.close'| translate}}</button>
